module.exports = __webpack_public_path__ + "img/71f50f7.jpg";